'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _validateIf = require('../validate-if');
var _validateIf2 = _interopRequireDefault(_validateIf);
var _isAlphanumerical = require('../is-alphanumerical');
var _isAlphanumerical2 = _interopRequireDefault(_isAlphanumerical);
var _looksLikePostcode = require('../looks-like-postcode');
var _looksLikePostcode2 = _interopRequireDefault(_looksLikePostcode);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
exports.default = function () {
  var _ref;
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'address';
  return _ref = {}, _defineProperty(_ref, id + 'Postcode', (0, _looksLikePostcode2.default)()), _defineProperty(_ref, id + 'Line1', (0, _isAlphanumerical2.default)('Please let us know the 1st line of your address')), _defineProperty(_ref, id + 'Line2', (0, _validateIf2.default)(function (value) {
    return !!value;
  }, (0, _isAlphanumerical2.default)('Please let us know the 2nd line of your address'))), _defineProperty(_ref, id + 'TownCity', (0, _isAlphanumerical2.default)('Please let us know the town/city')), _defineProperty(_ref, id + 'County', (0, _validateIf2.default)(function (value) {
    return !!value;
  }, (0, _isAlphanumerical2.default)('Please let us know the county'))), _ref;
};